<template>
  <div v-if="page">
    คุณได้เลือก {{ page.title }} <a class="btn-clear" href="#" @click.prevent="clear" v-if="clearButton">เลือกใหม่</a>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      default: null
    },
    clearButton: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    clear () {
      this.$emit('clear')
    }
  }
}
</script>

<style lang="scss" scoped>

.btn-clear {
  display: inline-block;
  text-indent: -999em;
  background: url("../assets/img/x@2x.png") no-repeat;
  width: 25px;
  background-size: 25px;
}
</style>



// WEBPACK FOOTER //
// PagePreview.vue?7780f3d8